import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"
import { getCategories } from "@/api/categoryApi"

export default function CategoryListPage() {
    const navigate = useNavigate()
    const [categories, setCategories] = useState<any[]>([])

    useEffect(() => {
        const fetchAllCategories = async () => {
            const res = await getCategories()
            console.log(res)
            setCategories(res.data.items || res.data || [])
        }
        fetchAllCategories()
    }, [])

    return (
        <div className="min-h-screen bg-slate-50">
            <Header />
            <main className="mx-auto max-w-7xl px-4 py-10 lg:px-6">
                <h2 className="text-3xl font-bold text-slate-900 mb-8">전체 카테고리</h2>

                <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    {categories.map((category) => (
                        <div
                            key={category.categoryId}
                            onClick={() => navigate(`/products?categoryId=${category.categoryId}`)}
                            className="flex flex-col items-center justify-center rounded-[24px] bg-white p-8 text-center shadow-sm transition-all hover:-translate-y-1 hover:shadow-md cursor-pointer border border-slate-200"
                        >
                            {/*<div className="text-5xl mb-4">{category.icon}</div>*/}
                            <div className="mb-4 h-16 w-16 overflow-hidden rounded-2xl flex items-center justify-center">
                                {category.icon && category.icon.startsWith('http') ? (
                                    <img src={category.icon} alt={category.name} className="h-full w-full object-cover" />
                                ) : (
                                    <div className="text-4xl">{category.icon || "📁"}</div> // 예외 처리 (이모지나 빈 값)
                                )}
                            </div>
                            <h3 className="text-xl font-bold text-slate-900">{category.name}</h3>
                            {/*<p className="mt-2 text-sm text-slate-500">{category.description}</p>*/}
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    )
}